var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"main-title"},[_c('h1',[_vm._v("Romatch")]),_c('p',[_vm._v("Werving en selectie")])]),_c('div',{staticClass:"image"})])}]

export { render, staticRenderFns }